module.exports = __webpack_public_path__ + "media/images/icn-time-fbc71562391e591d50b5eec62caeec06.png";